/**
 * Facets drawer — connectedCallback re-binds close (X) after AJAX updates.
 */
class FacetsMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.mainDetailsToggle = this.querySelector('details.facets-drawer__disclosure');
    this.bindEvents();
  }

  bindEvents() {
    this.mainDetailsToggle = this.querySelector('details.facets-drawer__disclosure');

    const mainSummary = this.mainDetailsToggle?.querySelector(':scope > summary');
    if (mainSummary) {
      mainSummary.removeEventListener('click', this._onMainSummaryClick);
      mainSummary.addEventListener('click', (this._onMainSummaryClick = this.onMainSummaryClick.bind(this)));
    }

    this.querySelectorAll('.facets-drawer__close, .mobile-facets__close-btn').forEach((button) => {
      button.removeEventListener('click', this._onCloseClick);
      button.addEventListener('click', (this._onCloseClick = this.onCloseClick.bind(this)));
    });

    this.querySelectorAll('.facets-drawer__overlay').forEach((overlay) => {
      overlay.removeEventListener('click', this._onOverlayClick);
      overlay.addEventListener('click', (this._onOverlayClick = this.onCloseClick.bind(this)));
    });
  }

  openDrawer() {
    const details = this.mainDetailsToggle;
    if (!details || details.hasAttribute('open')) return;

    details.setAttribute('open', '');
    window.requestAnimationFrame(() => {
      details.classList.add('menu-opening');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint || 'desktop'}`);
      const openBtn = document.getElementById('FacetsDrawerOpen');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    });
  }

  onMainSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (isOpen) {
      event.preventDefault();
      this.closeDrawer();
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint || 'desktop'}`);
        const openBtn = document.getElementById('FacetsDrawerOpen');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      });
    }
  }

  onCloseClick(event) {
    event.preventDefault();
    this.closeDrawer();
  }

  closeDrawer() {
    const details = this.mainDetailsToggle;
    if (!details) return;

    details.classList.remove('menu-opening');
    details.querySelector('summary')?.setAttribute('aria-expanded', false);
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint || 'desktop'}`);

    const openBtn = document.getElementById('FacetsDrawerOpen');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');

    window.requestAnimationFrame(() => {
      setTimeout(() => details.removeAttribute('open'), 300);
    });
  }
}

customElements.define('facets-menu-drawer', FacetsMenuDrawer);
